"use client";

import { useState } from "react";

import { FeelingsModal } from "@/components/dialog/feelings-modal";
import PostModal from "@/components/dialog/post-details-modal";
import { CreatePostForm } from "@/components/posts/create-post-form";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from "@/components/ui/dialog";
import { useStore } from "@/store/store";

export function GlobalModal() {
  const {
    isOpen,
    setIsOpen,
    showFeelingsModal,
    setShowFeelingsModal,
    handleFeelingSelect,
    setFeeling,
    removeFiles,
    selectedPostId,
  } = useStore();

  const [showConfirmClose, setShowConfirmClose] = useState(false);

  const onSelect = (feeling: Feeling) => {
    handleFeelingSelect(feeling);
    setIsOpen(true);
  };

  const handleCloseRequest = (open: boolean) => {
    if (!open) {
      setShowConfirmClose(true);
    }
 else {
      setIsOpen(true);
    }
  };

  const discardChanges = () => {
    removeFiles();
    setIsOpen(false);
    setShowConfirmClose(false);
    setFeeling(null);
  };

  return (
    <>
      <Dialog open={isOpen} onOpenChange={handleCloseRequest}>
        <DialogContent
          onPointerDownOutside={e => e.preventDefault()}
          className="max-w-[330px] md:max-w-xl max-h-[450px] p-0 overflow-scroll"
        >
          <DialogTitle className="sr-only">Post Form</DialogTitle>
          <div>
            <CreatePostForm />
          </div>
        </DialogContent>
      </Dialog>

      <FeelingsModal
        open={showFeelingsModal}
        onOpenChange={setShowFeelingsModal}
        onSelect={onSelect}
      />

      <AlertDialog open={showConfirmClose} onOpenChange={setShowConfirmClose}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Discard changes?</AlertDialogTitle>
            <AlertDialogDescription>
              If you close now, all your post content will be lost.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel
              onClick={() => setShowConfirmClose(false)}
              className="rounded-lg"
            >
              Continue editing
            </AlertDialogCancel>
            <AlertDialogAction
              onClick={discardChanges}
              className="bg-red-500 text-white hover:bg-red-600 rounded-lg"
            >
              Discard
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      {
        selectedPostId && <PostModal id={selectedPostId} />
      }
    </>
  );
}
